
<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR LABORATORIOS</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        lineas:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre Laboratorio *',key:'nombre'},
            {tipo:'texto',valor:'',label:'Contacto',key:'contacto'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Laboratorio',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'nombre',
                    class:'cabecera'
                },
                {
                    text: 'Contacto',
                    align: 'center',
                    sortable: true,
                    value: 'contacto',
                    class:'cabecera'
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {

    },
    mounted() {
        this.cargarDatos()
    },
    methods: {
        async cargarDatos(){
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}laboratorios`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones)
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
                this.errorMessage(error, "Error")
            })
        },
        
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Laboratorio'
            this.configuracion_modal.boton_submit = 'Crear'
            this.configuracion_modal.ruta = 'laboratorios'
            this.configuracion_modal.tipo_peticion = 'POST'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            this.inputs.forEach(input => {
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor
                    }
                });
            });
            this.configuracion_modal.titulo_modal = 'Editar Laboratorio'
            this.configuracion_modal.boton_submit = 'Actualizar'
            this.configuracion_modal.ruta = `laboratorios/${$event.id}`
            this.configuracion_modal.tipo_peticion = 'PUT'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>